import styled from 'styled-components';
import { SystemMessage } from '../styles';

interface BaseProps {
	hasSelection?: boolean;
	alwaysShow?: boolean;
}

export const Base = styled.div<BaseProps>`
	display: flex;
	gap: 2px;
	align-items: center;
	opacity: ${({ hasSelection, alwaysShow }) => (hasSelection || alwaysShow ? 1 : 0)};
	transition: opacity 0.1s ease;

	${SystemMessage}:hover & {
		opacity: 1;
	}
	margin-bottom: 4px;
	cursor: default;
`;

interface ButtonProps {
	isActive?: boolean;
}

export const Button = styled.button<ButtonProps>`
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 4px;
	border-radius: 4px;
	border: none;
	background: ${({ theme, isActive }) => (isActive ? theme.blue[300] : 'transparent')};
	transition: background 0.15s;

	&:hover {
		background: ${({ theme, isActive }) => (isActive ? theme.blue[300] : theme.gray[200])};
	}
`;
